import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

const BenefitsSection = ({ benefits_section }) => {
  

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    <Typography variant="h2">
        {benefits_section.header_title}
    </Typography>
    <Box sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridTemplateRows: 'repeat(2, 1fr)',
        gridAutoFlow: 'column',
        gridAutoColumns: 'minmax(200px, 1fr)',
        gap: 1,
        maxWidth: '100%',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
    }}>
        {benefits_section.sliders?.map((benefit, index) => (
        <Box key={index} sx={{
            background: '#fff',
            borderRadius: 2,
            minWidth: { xs: '146px', md: '174px'},
            minHeight: {xs: '150px', md: '150px'},
            position: 'relative',
            overflow: 'hidden',
        }}>
            <Box
            sx={{
                p: 1,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                position: 'relative',
                zIndex: 2,
            }}
            >
            <Box sx={{ display: 'flex',flexDirection: 'column', gap: 0.5}}>
                <Box
                    component="img"
                    src={benefit.benefit_icon}
                    alt={benefit.title}
                    sx={{ width: {xs: 24, md: 32}, height: {xs: 24, md: 32}}}
                />
                <Typography variant="labelD">
                    {benefit.title}
                </Typography>
            </Box>
            <Typography variant="p3" sx={{ color: '#666' }}>
                {benefit.description}
            </Typography>
            {benefit.img && (
                <Box
                component={'img'}
                src={benefit?.img}
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    width: 'auto',
                    height: 'auto',
                    zIndex: 1,
                }}
                />
            )}
            </Box>
        </Box>
        ))}
    </Box>
    </Box>
  );
};

export default BenefitsSection;